import {images} from "../constants/images";

export const openTrackingLink = (code) => {
  window.open(`${import.meta.env.REACT_APP_RECIPIENT_URL}/${code}`, "_blank", "noopener");
};

// length x width x height
export const renderDimension = d => `${d.length} x ${d.width} x ${d.height}`;

export const dimensionUnitDefault = 'in';
export const weightUnitDefault = 'lbs';

export const getParcelTypeIcon = type => {
  switch (type) {
    case 'bag':
      return images.icon.bag;
    case 'tote':
      return images.icon.tote;
    case 'box':
    case 'pallet':
    default:
      return images.icon.box;
  }
};
